import { createActions, handleActions } from 'redux-actions';

const { hideSidebar, showSidebar, toggleSidebar } = createActions('HIDE_SIDEBAR', 'SHOW_SIDEBAR', 'TOGGLE_SIDEBAR');

const reducer = handleActions(
    {
        [hideSidebar]: () => ({
            visible: false
        }),
        [showSidebar]: () => ({
            visible: true
        }),
        [toggleSidebar]: ({ visible }) => ({
            visible: !visible
        })
    },
    {
        visible: false
    }
)

export {
    hideSidebar,
    showSidebar,
    toggleSidebar
};
export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/navigationSidebar.js